import { render, staticRenderFns } from "./sichuan.vue?vue&type=template&id=7e1e208a&scoped=true"
import script from "./sichuan.vue?vue&type=script&lang=js"
export * from "./sichuan.vue?vue&type=script&lang=js"
import style0 from "./sichuan.vue?vue&type=style&index=0&id=7e1e208a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1e208a",
  null
  
)

export default component.exports